import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { injectIntl } from 'react-intl';

import { gaEvent } from '../../../utils/googleAnalytics';
import ConfirmedCardInfoView from './ConfirmedCardInfoView';
import messages from './messagesConfirmedCardInfo';
import inlineStyles from './styles';

function ConfirmedCardInfoDialog({
    classes,
    open,
    onClose,
    intl,
    orderId,
    booking,
}) {
    const closeAction = () => {
        gaEvent('confirmationInformationClose');
        onClose();
    };

    let confirmedCardInfo = null;
    if (orderId) {
        const order = booking.BookingOrders.find((orderItem) => orderItem.BookingOrderID === orderId);
        confirmedCardInfo = (order) ? order.BookingOrderConfirmationTypeInfo : null;
    }

    return (
        <Dialog
            open={open}
            onClose={closeAction}
            classes={{ paper: classes.dialogPaper }}
            disableEnforceFocus
            maxWidth={false}
        >
            <DialogTitle>{intl.formatMessage(messages.lblTitle)}</DialogTitle>
            <DialogContent classes={{ root: classes.dialogContent }}>
                {confirmedCardInfo !== null && (
                    <ConfirmedCardInfoView
                        confirmedCardInfo={confirmedCardInfo}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    id="srtConfirmedCardViewClose"
                    onClick={closeAction}
                >
                    {intl.formatMessage(messages.btnClose)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ConfirmedCardInfoDialog.propTypes = {
    intl: PropTypes.object,
    booking: PropTypes.object,
    orderId: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default injectIntl(withStyles(inlineStyles)(ConfirmedCardInfoDialog));
